const defineCountry = ({
  name,
  isoCode,
  dialCode,
  digits,
  aliases = [],
  displayLabel = name
}) => ({
  name,
  isoCode,
  dialCode,
  digits,
  aliases,
  displayLabel
});

export const PREVIEW_COUNTRY_GROUPS = [
  {
    label: "East Africa",
    options: [
      defineCountry({ name: "Uganda", isoCode: "UG", dialCode: "+256", digits: 9, aliases: ["UG"] }),
      defineCountry({ name: "Kenya", isoCode: "KE", dialCode: "+254", digits: 9, aliases: ["KE"] }),
      defineCountry({ name: "Tanzania", isoCode: "TZ", dialCode: "+255", digits: 9, aliases: ["TZ", "United Republic of Tanzania"] }),
      defineCountry({ name: "Rwanda", isoCode: "RW", dialCode: "+250", digits: 9, aliases: ["RW"] }),
      defineCountry({ name: "Burundi", isoCode: "BI", dialCode: "+257", digits: 8, aliases: ["BI"] }),
      defineCountry({ name: "Ethiopia", isoCode: "ET", dialCode: "+251", digits: 9, aliases: ["ET"] }),
      defineCountry({ name: "South Sudan", isoCode: "SS", dialCode: "+211", digits: 9, aliases: ["SS"] }),
      defineCountry({ name: "Somalia", isoCode: "SO", dialCode: "+252", digits: 8, aliases: ["SO", "Federal Republic of Somalia"] }),
      defineCountry({ name: "Djibouti", isoCode: "DJ", dialCode: "+253", digits: 8, aliases: ["DJ"] }),
      defineCountry({ name: "Eritrea", isoCode: "ER", dialCode: "+291", digits: 7, aliases: ["ER"] })
    ]
  },
  {
    label: "Africa",
    options: [
      defineCountry({
        name: "Democratic Republic of the Congo",
        isoCode: "CD",
        dialCode: "+243",
        digits: 9,
        aliases: [
          "CD",
          "DR Congo",
          "DRC",
          "Congo - Kinshasa",
          "Congo Kinshasa",
          "Congo (DRC)",
          "Democratic Republic Of Congo"
        ]
      }),
      defineCountry({ name: "South Africa", isoCode: "ZA", dialCode: "+27", digits: 9, aliases: ["ZA"] }),
      defineCountry({ name: "Nigeria", isoCode: "NG", dialCode: "+234", digits: 10, aliases: ["NG"] }),
      defineCountry({ name: "Ghana", isoCode: "GH", dialCode: "+233", digits: 9, aliases: ["GH"] }),
      defineCountry({ name: "Egypt", isoCode: "EG", dialCode: "+20", digits: 10, aliases: ["EG"] }),
      defineCountry({ name: "Morocco", isoCode: "MA", dialCode: "+212", digits: 9, aliases: ["MA"] })
    ]
  },
  {
    label: "Asia & Middle East",
    options: [
      defineCountry({ name: "India", isoCode: "IN", dialCode: "+91", digits: 10, aliases: ["IN"] }),
      defineCountry({ name: "Pakistan", isoCode: "PK", dialCode: "+92", digits: 10, aliases: ["PK"] }),
      defineCountry({ name: "Bangladesh", isoCode: "BD", dialCode: "+880", digits: 10, aliases: ["BD"] }),
      defineCountry({ name: "Sri Lanka", isoCode: "LK", dialCode: "+94", digits: 9, aliases: ["LK"] }),
      defineCountry({ name: "Nepal", isoCode: "NP", dialCode: "+977", digits: 10, aliases: ["NP"] }),
      defineCountry({ name: "China", isoCode: "CN", dialCode: "+86", digits: 11, aliases: ["CN", "People's Republic of China", "PRC"] }),
      defineCountry({ name: "Japan", isoCode: "JP", dialCode: "+81", digits: 10, aliases: ["JP"] }),
      defineCountry({ name: "South Korea", isoCode: "KR", dialCode: "+82", digits: 10, aliases: ["KR", "Korea", "Republic of Korea", "Korea, Republic of"] }),
      defineCountry({ name: "Singapore", isoCode: "SG", dialCode: "+65", digits: 8, aliases: ["SG"] }),
      defineCountry({ name: "Malaysia", isoCode: "MY", dialCode: "+60", digits: 9, aliases: ["MY"] }),
      defineCountry({ name: "Thailand", isoCode: "TH", dialCode: "+66", digits: 9, aliases: ["TH"] }),
      defineCountry({ name: "Vietnam", isoCode: "VN", dialCode: "+84", digits: 9, aliases: ["VN", "Viet Nam"] }),
      defineCountry({ name: "Indonesia", isoCode: "ID", dialCode: "+62", digits: 9, aliases: ["ID"] }),
      defineCountry({ name: "Philippines", isoCode: "PH", dialCode: "+63", digits: 10, aliases: ["PH"] }),
      defineCountry({ name: "United Arab Emirates", isoCode: "AE", dialCode: "+971", digits: 9, aliases: ["AE", "UAE"] }),
      defineCountry({ name: "Saudi Arabia", isoCode: "SA", dialCode: "+966", digits: 9, aliases: ["SA", "Kingdom of Saudi Arabia"] }),
      defineCountry({ name: "Qatar", isoCode: "QA", dialCode: "+974", digits: 8, aliases: ["QA"] }),
      defineCountry({ name: "Kuwait", isoCode: "KW", dialCode: "+965", digits: 8, aliases: ["KW"] }),
      defineCountry({ name: "Oman", isoCode: "OM", dialCode: "+968", digits: 8, aliases: ["OM"] }),
      defineCountry({ name: "Bahrain", isoCode: "BH", dialCode: "+973", digits: 8, aliases: ["BH"] }),
      defineCountry({ name: "Jordan", isoCode: "JO", dialCode: "+962", digits: 9, aliases: ["JO"] }),
      defineCountry({ name: "Lebanon", isoCode: "LB", dialCode: "+961", digits: 8, aliases: ["LB"] }),
      defineCountry({ name: "Israel", isoCode: "IL", dialCode: "+972", digits: 9, aliases: ["IL"] })
    ]
  },
  {
    label: "Europe",
    options: [
      defineCountry({ name: "United Kingdom", isoCode: "GB", dialCode: "+44", digits: 10, aliases: ["GB", "UK", "Great Britain"] }),
      defineCountry({ name: "Ireland", isoCode: "IE", dialCode: "+353", digits: 9, aliases: ["IE"] }),
      defineCountry({ name: "France", isoCode: "FR", dialCode: "+33", digits: 9, aliases: ["FR"] }),
      defineCountry({ name: "Germany", isoCode: "DE", dialCode: "+49", digits: 11, aliases: ["DE"] }),
      defineCountry({ name: "Netherlands", isoCode: "NL", dialCode: "+31", digits: 9, aliases: ["NL", "The Netherlands"] }),
      defineCountry({ name: "Belgium", isoCode: "BE", dialCode: "+32", digits: 9, aliases: ["BE"] }),
      defineCountry({ name: "Switzerland", isoCode: "CH", dialCode: "+41", digits: 9, aliases: ["CH"] }),
      defineCountry({ name: "Italy", isoCode: "IT", dialCode: "+39", digits: 10, aliases: ["IT"] }),
      defineCountry({ name: "Spain", isoCode: "ES", dialCode: "+34", digits: 9, aliases: ["ES"] }),
      defineCountry({ name: "Portugal", isoCode: "PT", dialCode: "+351", digits: 9, aliases: ["PT"] }),
      defineCountry({ name: "Sweden", isoCode: "SE", dialCode: "+46", digits: 9, aliases: ["SE"] }),
      defineCountry({ name: "Norway", isoCode: "NO", dialCode: "+47", digits: 8, aliases: ["NO"] }),
      defineCountry({ name: "Denmark", isoCode: "DK", dialCode: "+45", digits: 8, aliases: ["DK"] }),
      defineCountry({ name: "Finland", isoCode: "FI", dialCode: "+358", digits: 9, aliases: ["FI"] }),
      defineCountry({ name: "Poland", isoCode: "PL", dialCode: "+48", digits: 9, aliases: ["PL"] }),
      defineCountry({ name: "Austria", isoCode: "AT", dialCode: "+43", digits: 9, aliases: ["AT"] }),
      defineCountry({ name: "Czechia", isoCode: "CZ", dialCode: "+420", digits: 9, aliases: ["CZ", "Czech Republic"] }),
      defineCountry({ name: "Slovakia", isoCode: "SK", dialCode: "+421", digits: 9, aliases: ["SK", "Slovak Republic"] }),
      defineCountry({ name: "Slovenia", isoCode: "SI", dialCode: "+386", digits: 8, aliases: ["SI"] }),
      defineCountry({ name: "Hungary", isoCode: "HU", dialCode: "+36", digits: 9, aliases: ["HU"] }),
      defineCountry({ name: "Croatia", isoCode: "HR", dialCode: "+385", digits: 9, aliases: ["HR"] }),
      defineCountry({ name: "Serbia", isoCode: "RS", dialCode: "+381", digits: 9, aliases: ["RS"] }),
      defineCountry({ name: "Bulgaria", isoCode: "BG", dialCode: "+359", digits: 9, aliases: ["BG"] }),
      defineCountry({ name: "Romania", isoCode: "RO", dialCode: "+40", digits: 9, aliases: ["RO"] }),
      defineCountry({ name: "Greece", isoCode: "GR", dialCode: "+30", digits: 10, aliases: ["GR"] }),
      defineCountry({ name: "Lithuania", isoCode: "LT", dialCode: "+370", digits: 8, aliases: ["LT"] }),
      defineCountry({ name: "Latvia", isoCode: "LV", dialCode: "+371", digits: 8, aliases: ["LV"] }),
      defineCountry({ name: "Estonia", isoCode: "EE", dialCode: "+372", digits: 7, aliases: ["EE"] }),
      defineCountry({ name: "Turkey", isoCode: "TR", dialCode: "+90", digits: 10, aliases: ["TR", "Türkiye"] }),
      defineCountry({ name: "Ukraine", isoCode: "UA", dialCode: "+380", digits: 9, aliases: ["UA"] })
    ]
  },
  {
    label: "North America",
    options: [
      defineCountry({
        name: "United States",
        isoCode: "US",
        dialCode: "+1",
        digits: 10,
        aliases: ["US", "USA", "United States of America"],
        displayLabel: "USA"
      }),
      defineCountry({ name: "Canada", isoCode: "CA", dialCode: "+1", digits: 10, aliases: ["CA"] }),
      defineCountry({ name: "Mexico", isoCode: "MX", dialCode: "+52", digits: 10, aliases: ["MX"] })
    ]
  },
  {
    label: "South America",
    options: [
      defineCountry({ name: "Brazil", isoCode: "BR", dialCode: "+55", digits: 11, aliases: ["BR"] }),
      defineCountry({ name: "Argentina", isoCode: "AR", dialCode: "+54", digits: 11, aliases: ["AR"] }),
      defineCountry({ name: "Chile", isoCode: "CL", dialCode: "+56", digits: 9, aliases: ["CL"] }),
      defineCountry({ name: "Colombia", isoCode: "CO", dialCode: "+57", digits: 10, aliases: ["CO"] }),
      defineCountry({ name: "Peru", isoCode: "PE", dialCode: "+51", digits: 9, aliases: ["PE"] }),
      defineCountry({ name: "Venezuela", isoCode: "VE", dialCode: "+58", digits: 10, aliases: ["VE"] }),
      defineCountry({ name: "Uruguay", isoCode: "UY", dialCode: "+598", digits: 8, aliases: ["UY"] }),
      defineCountry({ name: "Paraguay", isoCode: "PY", dialCode: "+595", digits: 9, aliases: ["PY"] }),
      defineCountry({ name: "Bolivia", isoCode: "BO", dialCode: "+591", digits: 8, aliases: ["BO"] }),
      defineCountry({ name: "Ecuador", isoCode: "EC", dialCode: "+593", digits: 9, aliases: ["EC"] })
    ]
  },
  {
    label: "Oceania",
    options: [
      defineCountry({ name: "Australia", isoCode: "AU", dialCode: "+61", digits: 9, aliases: ["AU"] }),
      defineCountry({ name: "New Zealand", isoCode: "NZ", dialCode: "+64", digits: 9, aliases: ["NZ"] })
    ]
  }
];

export const PREVIEW_COUNTRY_OPTIONS = PREVIEW_COUNTRY_GROUPS.flatMap(
  (group) => group.options
);

const normalizeLookupValue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[().,'-]+/g, " ")
    .replace(/\s+/g, " ");

const PREVIEW_COUNTRY_LOOKUP = PREVIEW_COUNTRY_OPTIONS.reduce((lookup, option) => {
  const keys = [option.name, option.isoCode, ...option.aliases];

  keys.forEach((key) => {
    const normalizedKey = normalizeLookupValue(key);
    if (normalizedKey) {
      lookup[normalizedKey] = option;
    }
  });

  return lookup;
}, {});

export const getPreviewCountryPhoneConfig = (country) =>
  PREVIEW_COUNTRY_LOOKUP[normalizeLookupValue(country)] || null;

export const normalizePreviewCountrySelection = (country) =>
  getPreviewCountryPhoneConfig(country)?.name || String(country || "").trim();

export const sanitizePreviewNationalPhone = (value, country) => {
  const digitsOnly = String(value || "").replace(/\D/g, "");
  const config = getPreviewCountryPhoneConfig(country);

  if (!config) {
    return digitsOnly;
  }

  let nextDigits = digitsOnly;

  if (nextDigits.startsWith("0") && nextDigits.length === config.digits + 1) {
    nextDigits = nextDigits.slice(1);
  }

  return nextDigits.slice(0, config.digits);
};

export const extractPreviewNationalPhone = (value, country) => {
  const digitsOnly = String(value || "").replace(/\D/g, "");
  const config = getPreviewCountryPhoneConfig(country);

  if (!config) {
    return digitsOnly;
  }

  const dialDigits = config.dialCode.replace(/\D/g, "");
  let nationalDigits = digitsOnly.startsWith(dialDigits)
    ? digitsOnly.slice(dialDigits.length)
    : digitsOnly;

  if (nationalDigits.startsWith("0") && nationalDigits.length === config.digits + 1) {
    nationalDigits = nationalDigits.slice(1);
  }

  return nationalDigits.slice(0, config.digits);
};

export const formatPreviewPhoneNumber = (country, nationalPhone) => {
  const digitsOnly = String(nationalPhone || "").replace(/\D/g, "");
  const config = getPreviewCountryPhoneConfig(country);

  if (!digitsOnly) {
    return "";
  }

  if (!config) {
    return digitsOnly;
  }

  return `${config.dialCode} ${digitsOnly}`;
};

export const isValidPreviewPhoneForCountry = (country, nationalPhone) => {
  const digitsOnly = String(nationalPhone || "").replace(/\D/g, "");
  const config = getPreviewCountryPhoneConfig(country);

  if (!digitsOnly) {
    return true;
  }

  return Boolean(config && digitsOnly.length === config.digits);
};

export const getPreviewPhoneGuidance = (country) => {
  const config = getPreviewCountryPhoneConfig(country);

  if (!config) {
    return "Select a country first to load the dialing code and phone length.";
  }

  return `Enter ${config.digits} digits for ${config.name}.`;
};
